import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#rebrand-hedepy-plus_svg__a)">
      <path d="M8.425 9.203c-1.78 0-3.147.985-3.87 2.845v-1.557c0-1.407.079-2.846.42-4.1.342-1.282 1.098-2.235 2.123-3.103L5.922 1.882c-2.543 2.01-3.076 4.705-3.148 7.662v10.054h1.78v-4.934c0-2.616 1.328-4.062 3.148-4.062 2.05 0 2.695 1.328 2.695 3.266v5.73h1.748v-6.144c.04-2.464-1.176-4.251-3.72-4.251" />
      <path
        fill="#C592BF"
        d="M22.16 13.974h-3.654v-3.615h-1.504v3.615h-3.647v1.505h3.647v3.686h1.505V15.48h3.653z"
      />
    </g>
    <defs>
      <clipPath id="rebrand-hedepy-plus_svg__a">
        <path fill="#fff" d="M1.25 1.882h23v22.014h-23z" />
      </clipPath>
    </defs>
  </svg>
);
export const RebrandHedepyPlusIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
